import {Injectable} from '@angular/core';
import {RequestService} from './request.service';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {ConfigService} from './config.service';

@Injectable()
export class ScormCloudService {
  constructor(
    private requestService: RequestService,
    private http: Http,
    private configService: ConfigService
  ) {
  }
  getResults(deliverableId: string): Observable<any> {
    let url = this.configService.get('server').apiUrl + this.configService.get('endpoints').zephyr.results.api + '/' + deliverableId;
    return this.requestService.get(url);
  }

  getCourses(courseId: string): Observable<any> {
    let url = this.configService.get('server').apiUrl + this.configService.get('endpoints').zephyr.courses.details.api + '/' + courseId;
    return this.requestService.get(url);
  }

  getRegistrations(registrationId: string, brandedUrl: string): Observable<any> {
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').zephyr.registration.api + '/' + registrationId+ '?redirectUrl='+brandedUrl;
    return this.requestService.get(url);
  }

  importCourse(data: any){
    /*
    bucket, key, solarDeliverableId
     */
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').zephyr.courses.import.api;
    return this.requestService.post(url, data);
  }

  importEvaluationCourse(data: any){
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').zephyr.evaluation.courses.import.api;
    return this.requestService.post(url, data);
  }

  getImportTokenId(deliverableId: string){
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.deliverable.token.api + '/' + deliverableId;
    return Observable
      .timer(0, 5000)
      .switchMap(() => this.requestService.get(url))
      .map(response => response.data);
  }

  getImportEvaluationTokenId(deliverableId: string){
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.deliverable.evaluation.token.api + '/' + deliverableId;
    return Observable
      .timer(0, 5000)
      .switchMap(() => this.requestService.get(url))
      .map(response => response.data);
  }

  checkImportResults(tokenId: string){
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').zephyr.courses.result.api + '/' + tokenId;
    return Observable
      .timer(0, 5000)
      .switchMap(() => this.requestService.get(url))
      .map(response => response.data);
  }

  createRegistration(data: any){
    console.log(data)
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').zephyr.createRegistration.api;
    return this.requestService.post(url, data);
  }

  updateRegistrationId(data: any){
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.deliverable.updateRegistrationId.api;
    return this.requestService.post(url, data);
  }

  updateEvaluationRegistrationId(data: any){
    let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.deliverable.evaluation.updateRegistrationId.api;
    return this.requestService.post(url, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/scorm-cloud.service.ts